var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrikethrough(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75195 8.92318H13.4186M12.752 6.25651V6.08984C12.752 4.98527 11.8565 4.08984 10.752 4.08984H6.41862C5.31405 4.08984 4.41862 4.98527 4.41862 6.08984V6.92318C4.41862 8.02775 5.31405 8.92318 6.41862 8.92318H10.5853M4.41862 11.2565V11.5898C4.41862 12.6944 5.31405 13.5898 6.41862 13.5898H10.752C11.8565 13.5898 12.752 12.6944 12.752 11.5898V10.5898",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikethrough);
export default __webpack_public_path__ + "static/media/strikethrough.7803a0979b19fd3c5ecad1a253e11458.svg";
export { ForwardRef as ReactComponent };